const _require = require('@truqc/content-path'),
  getContentValue = _require.getContentValue,
  getFlattenedContentValues = _require.getFlattenedContentValues;
const _require2 = require('../lib/evaluateSource'),
  combForSource = _require2.combForSource,
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate ifValueBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const comb = await combForSource(source, content, parentContentPath, transientContext, nativeFunctions);
  const boundEvaluateSource = subsource => evaluateSource(subsource, content, parentContentPath, transientContext, nativeFunctions);
  const value = await boundEvaluateSource(source.value);
  if (value === undefined) {
    return false;
  }
  const atPath = await boundEvaluateSource(source.atPath);
  if (atPath !== undefined) {
    const subvalue = getContentValue(atPath, value);
    return comb(subvalue);
  }
  const getEvaluatedValues = async (paths, requireAllValues) => {
    const evaluatedPaths = (await boundEvaluateSource(paths)) || [];
    return getFlattenedContentValues(evaluatedPaths, value, requireAllValues);
  };
  const atAnyPaths = await boundEvaluateSource(source.atAnyPaths);
  if (atAnyPaths !== undefined) {
    const values = await getEvaluatedValues(atAnyPaths, false);
    return values ? values.length > 0 && values.some(comb) : false;
  }
  const atAllPaths = await boundEvaluateSource(source.atAllPaths);
  if (atAllPaths !== undefined) {
    const values = await getEvaluatedValues(atAllPaths, true);
    return values ? values.length > 0 && values.every(comb) : false;
  }
  return comb(value);
};
module.exports = {
  evaluate
};